import { useEffect, useRef } from "react";
import { Form, Input, message, Typography } from "antd";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { setFormType } from "../../../../redux/slices/roleUserSlice";
import { createGroup } from "../../../../services/adminServices";
import { showLoader } from "../../../../utils/showloader";
import { trimStringValues } from "../../../../utils/trimStrings";
import { ArrowLeftOutlined } from "@ant-design/icons";
import UserRoleDropdown from "../../../UserRoleDropdown";

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 6 }, // Adjust the span for width
};

// Adapter so UserRoleDropdown (user-only) works as an antd Form control.
// Keeps the field value as an array of JSON strings { name, email } to stay
// compatible with the existing group submit logic.
const UserPickerField = ({ value = [], onChange, allUsers = [] }) => {
    const { t } = useTranslation();
    const nameByEmail = useRef({});

    const parsed = (value || [])
        .map((v) => {
            try {
                return typeof v === "string" ? JSON.parse(v) : v;
            } catch {
                return null;
            }
        })
        .filter(Boolean);

    // Seed the email -> name lookup from the current value and the known users list.
    parsed.forEach((u) => {
        if (u?.email) nameByEmail.current[u.email] = u.name || nameByEmail.current[u.email];
    });
    allUsers.forEach((u) => {
        if (u?.email && !nameByEmail.current[u.email]) nameByEmail.current[u.email] = u.name;
    });

    const selectedOptions = {
        user: parsed.map((u) => u.email),
        role: [],
        group: [],
    };

    const handleSelect = (newOptions, lists) => {
        const emails = newOptions?.user || [];
        (lists?.userList || []).forEach((u) => {
            if (u?.email) nameByEmail.current[u.email] = u.name;
        });
        const next = emails.map((email) =>
            JSON.stringify({ name: nameByEmail.current[email] || email, email })
        );
        onChange?.(next);
    };

    return (
        <UserRoleDropdown
            placeholder={t("Search and select users")}
            selectedOptions={selectedOptions}
            onSelect={handleSelect}
            tabsRequired={["user"]}
        />
    );
};

const AddEditGroup = (props) => {
    const { selectedGroup, userInfo, submitGroup, reloadTable, setShowForm, users, setSubmitGroup } = props
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [form] = Form.useForm();

    useEffect(() => {
        if (submitGroup) {
            form.submit()
        }
    }, [submitGroup])


    useEffect(() => {
        form.resetFields();
    }, [])


    useEffect(() => {
        if (selectedGroup) {
            form.setFieldsValue({
                name: selectedGroup.name,
                users: selectedGroup.users?.map(user =>
                    JSON.stringify({ name: user.name, email: user.email })
                ),
            });
        } else {
            form.resetFields();
        }
    }, [selectedGroup]);


    const onSaveGroup = async (values) => {
        let postData = { ...values }
        if (selectedGroup) {
            postData.groupId = selectedGroup.groupId
        }
        showLoader(true)
        let userResp = await createGroup(postData, userInfo)
        showLoader(false)
        setSubmitGroup(false)
        if (userResp.status === 200) {
            message.success(userResp.message);
            dispatch(setFormType(""))
            setShowForm(false)
            reloadTable();
            if (selectedGroup) {
                props.setSelectedGroup(null)
            }
        } else {
            message.error(userResp.message)
        }
    }

    const onSubmitGroup = async (values) => {
        values = trimStringValues(values)
        let currentSelectedUsers = values.users.map(item => JSON.parse(item))
        let newlyAddedUsers = [], deletedUsers = []
        if(selectedGroup?.groupId) {
            selectedGroup.users.map(user => {
                let userInSelected = currentSelectedUsers.find(selectedUser => selectedUser.email === user.email)
                if(!userInSelected) {
                    deletedUsers.push({...user})
                } 
            })
            currentSelectedUsers.map(currentUser => {
                let userInSelected = selectedGroup.users.find(selectedUser => selectedUser.email === currentUser.email)
                if(!userInSelected) {
                    newlyAddedUsers.push({...currentUser})
                }
            }) 
            values.addedUsers = [...newlyAddedUsers]
            values.deletedUsers = [...deletedUsers]
            if(values.users){
                delete values.users
            }
        } else {
            values.users = [...currentSelectedUsers]
        }

        try {
            await form.validateFields();
            onSaveGroup(values)
        } catch (errorInfo) {
        }
        setSubmitGroup(false)
    }

    const goBack = () => {
        dispatch(setFormType(""))
            setShowForm(false)

    }

    return (
        <>
         <Typography.Title level={4} className="p-0 m-0" >
          <span><ArrowLeftOutlined className="cursor-pointer" style={{ marginRight: "12px" }} onClick={goBack}  />{selectedGroup ? t("Update Group") : t("Add Group") }</span>

            </Typography.Title>
            <Form form={form} onFinish={onSubmitGroup} layout="vertical" {...formItemLayout}>
                <Form.Item label={t("Group Name")} name="name" rules={[{ required: true, whitespace: true, message: t("Group name is required") }]}>
                    <Input placeholder={t("Enter group name")} />
                </Form.Item>
                <Form.Item label={t("Who should be in this group?")} name="users" rules={[{ required: true, message: t("Email ID is required") }]}>
                    <UserPickerField allUsers={users} />
                </Form.Item>
                {/* <Form.Item label="Description" name="description">
                    <Input placeholder="description" />
                </Form.Item> */}
            </Form>
        </>
    )
}

export default AddEditGroup